import styled from "styled-components";

import { handleBottomSpacing } from "js/helpers/spacingAndFonts";

export const Image = styled.div`
    ${handleBottomSpacing({ bottomSpacing: "lg" })}
    text-align: center;
`;
